export const apiEndpoint = process.env.REACT_APP_PRISMIC_URL;
export const accessToken = '';


// -- Link resolution rules
// Manages the url links to internal Prismic documents
export const linkResolver = (doc) => {
    if(doc.type === 'flujo_cotizacion_v2') return `/cotizacion/${doc.uid}`
    return '/'
}
